module.exports = __webpack_public_path__ + "img/forward-message.eb322317.png";